export const featuredConversationsVariant = "featuredConversationVariant";
export const allConversationsVariant = "allConversations";
